const LAYER_CLASSNAME_PREFIX = "tw:layer-";

import { VariantProps } from "tailwind-variants/dist/types.js";

import { layer as layerVariant } from "./layer.styles";

export type Layer = Required<VariantProps<typeof layerVariant>>["layer"];

const removeLayerClasses = <TElement extends HTMLElement>(
    element: TElement
) => {
    element.classList.forEach((className) => {
        if (!className.startsWith(LAYER_CLASSNAME_PREFIX)) return;
        element.classList.remove(className);
    });
};

const applyLayer = <TElement extends HTMLElement>(
    element: TElement,
    layer: Layer,
    layerAbove: boolean
) => {
    const layerToApply = layerVariant({ layer, layerAbove, force: true });
    element.classList.add(layerToApply);
};

const setLayer = <TElement extends HTMLElement>(
    element: TElement,
    layer: Layer,
    layerAbove: boolean = false
) => {
    removeLayerClasses(element);
    applyLayer(element, layer, layerAbove);
};

export { setLayer };
